import type { PropsWithChildren } from 'react';

/**
 * A React component that renders its children inside a div
 * with utility classes for alignment and sizing.
 *
 * @param children - The content to be rendered inside the controls container.
 * @returns A div wrapping the provided children, styled with "ms-auto shrink-0".
 */
export const Controls = ({ children }: PropsWithChildren) => {
  return <div className="ms-auto shrink-0">{children}</div>;
};
